import React, {useState, useEffect, useCallback} from "react";
import {
  Box,
  Button,
  Divider,
  Flex,
  Typography,
} from '@strapi/design-system';
import {getFetchClient, useNotification} from "@strapi/strapi/admin";
import {useParams} from "react-router-dom";
import {TriggerButtonInfo} from "../../../../server/src/types";

const Index = ({}) => {
  const {toggleNotification} = useNotification();
  const {slug, id: documentId,} = useParams<{ slug: string; id: string }>();
  const {get, post} = getFetchClient();

  const [loading, setLoading] = useState(false);
  const [triggerButtons, setTriggerButtons] = useState<TriggerButtonInfo[]>([]);

  const showNotification = (message: string, type: 'info' | 'warning' | 'danger' | 'success' = 'warning') => {
    toggleNotification({
      // required
      type,
      // required
      message: message,
    });
  }

  useEffect(() => {
    (async () => {
      const apiID = slug;
      if (!apiID) {
        return;
      }
      try {
        const response = await get(`/telegram-bot/telegram-action/get-buttons`, {
          params: {apiID},
          validateStatus: (status: number) => status === 200,
        });
        const {enabled, buttons} = response.data;

        setTriggerButtons(enabled ? buttons : [])
      } catch (e) {
        console.error(e);
      }
    })();
  }, [slug]);

  const handleClick = useCallback((buttonID: string) => async () => {
      const id = documentId;
      if (id) {
        setLoading(true);
        const response = await post(`/telegram-bot/telegram-action/trigger`, {buttonID: buttonID, id}, {
          headers: {
            'Content-Type': 'application/json',
          }
        });
        setLoading(false);
        const {type, message} = response.data;
        showNotification(message, type);
      } else showNotification('Please save the data before send notifications', 'warning');
    }
    , []);

  if (triggerButtons.length === 0) {
    return <></>;
  }

  return (
    <>
      <Box
        as="aside"
        aria-labelledby="telegram-additional-information"
        background="neutral0"
        borderColor="neutral150"
        hasRadius
        paddingBottom={4}
        paddingLeft={4}
        paddingRight={4}
        paddingTop={6}
        shadow="tableShadow"
         width="100%"
      >
        <Flex direction="column" alignItems="stretch" gap={4}>
          <Flex direction="column" alignItems="stretch" gap={2}>
            <Typography variant="sigma" textColor="neutral600" id="telegram-additional-information">
              Telegram Action
            </Typography>

            <Box>
              <Divider/>
            </Box>
          </Flex>
          <Flex direction="column" alignItems="stretch" gap={4}>
            <Flex direction="column" alignItems="stretch" gap={2} as="dl">
            </Flex>
          </Flex>


          {triggerButtons.map(({buttonID, label, variant}) => (
            <Button
              variant={variant || 'success-light'}
              key={buttonID} loading={loading}
              onClick={handleClick(buttonID)}>
              {label}
            </Button>
          ))}
        </Flex>
      </Box>
    </>
  )
}

export default Index;
